module.exports = new __parcel__URL__("illustration-dark.3097097c.svg").toString();